import { graphql, useStaticQuery } from "gatsby"

const parseAcceptanceRateFromSelectivity = (selectivityValue) => {
  const rawValues = Array.isArray(selectivityValue) ? selectivityValue : [selectivityValue]

  for (const value of rawValues) {
    const textValue = String(value || "")
    const percentMatch = textValue.match(/(\d{1,3}(?:\.\d+)?)\s*%/)

    if (!percentMatch) {
      continue
    }

    const parsedValue = Number(percentMatch[1])
    if (Number.isFinite(parsedValue)) {
      return parsedValue
    }
  }

  return undefined
}

export const useAllSchools = (locale) => {
  const { allCosmicjsSchools } = useStaticQuery(graphql`
    query {
      allCosmicjsSchools {
        edges {
          node {
            id
            slug
            title
            locale
            type
            content
            created_at
            published_at
            modified_at
            metadata {
              school_banner_image {
                imgix_url
              }
              school_keywords
              school_city
              school_state_or_region
              school_acceptance_rate
              school_enrolled_count
              school_selectivity_filter
              school_size_filter
              school_type_filter
              school_setting_filter
              school_cost_filter
            }
          }
        }
      }
    }
  `)

  const allItems = allCosmicjsSchools.edges.map(({ node }, index) => {
    const schoolSelectivityFilter = node.metadata?.school_selectivity_filter
    // const schoolAcceptanceRate = Number(node.metadata?.school_acceptance_rate)

    return {
      key: index,
      id: node.id,
      slug: node.slug,
      title: node.title,
      locale: node.locale,
      type: node.type,
      content: node.content,
      created_at: node.created_at,
      published_at: node.published_at,
      modified_at: node.modified_at,
      school_banner_image: node.metadata?.school_banner_image?.imgix_url,
      school_keywords: node.metadata?.school_keywords,
      school_city: node.metadata?.school_city,
      school_state_or_region: node.metadata?.school_state_or_region,
      school_acceptance_rate: node.metadata?.school_acceptance_rate,
      school_selectivity_filter: schoolSelectivityFilter,
      school_enrolled_count: node.metadata?.school_enrolled_count,
      school_size_filter: node.metadata?.school_size_filter,
      school_type_filter: node.metadata?.school_type_filter,
      school_setting_filter: node.metadata?.school_setting_filter,
      school_cost_filter: node.metadata?.school_cost_filter,
    }
  })

  if (!locale) {
    return allItems
  }

  return allItems.filter((item) => item.locale === locale)
}
